import { availablePaymentMethods } from '../../utils';

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  RETRIEVE_PASSWORD_REQUEST,
  RETRIEVE_PASSWORD_SUCCESS,
  RETRIEVE_PASSWORD_FAILURE,
  RETRIEVE_PASSWORD_RESET,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  DEFINE_USER_COORDINATES_SUCCESS,
  DEFINE_USER_COORDINATES_FAILURE,
  SOCIAL_REQUEST,
  SOCIAL_SUCCESS,
  SOCIAL_FAILURE,
  UPLOAD_AVATAR_REQUEST,
  UPLOAD_AVATAR_SUCCESS,
  UPLOAD_AVATAR_FAILURE,
  REMOVE_AVATAR_REQUEST,
  REMOVE_AVATAR_SUCCESS,
  REMOVE_AVATAR_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CANCEL_SUBSCRIPTION_REQUEST,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_FAILURE,
  ADD_CREDIT_REQUEST,
  ADD_CREDIT_SUCCESS,
  ADD_CREDIT_FAILURE,
  FETCH_USER_CARDS_REQUEST,
  FETCH_USER_CARDS_SUCCESS,
  FETCH_USER_CARDS_FAILURE,
} from '../types';

const initialState = {
  userData: null,
  cards: availablePaymentMethods,
  errors: {
    login: null,
    signup: null,
    forgot: null,
    logout: null,
    reset: null,
    uploadAvatar: null,
    removeAvatar: null,
    cancelSubscription: null,
    addCredit: null,
    updatePassword: null,
    coordinates: null,
    cards: null,
  },
  success: {
    login: false,
    signup: false,
    forgot: false,
    logout: false,
    reset: false,
    uploadAvatar: false,
    removeAvatar: false,
    cancelSubscription: false,
    addCredit: false,
    update: false,
    updatePassword: false,
    coordinates: false,
    cards: false,
  },
  newCredit: null,
  isFetching: false,
  wasFetched: false,
  location: {
    wasFetched: false,
    city: null,
    longitude: null,
    latitude: null,
  }
};

function successCaseFabric(type, state) {
  return {
    ...state,
    success: {
      ...state.success,
      [type]: true,
    },
    errors: {
      ...state.errors,
      [type]: null,
    },
    isFetching: false,
    wasFetched: true,
  }
}

function failureCaseFabric(type, state, payload = null) {
  return {
    ...state,
    success: {
      ...state.success,
      [type]: false,
    },
    errors: {
      ...state.errors,
      [type]: payload,
    },
    isFetching: false,
    wasFetched: true,
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case SIGNUP_REQUEST:
    case LOGOUT_REQUEST:
    case FETCH_USER_REQUEST:
    case RETRIEVE_PASSWORD_REQUEST:
    case UPDATE_PASSWORD_REQUEST:
    case SOCIAL_REQUEST:
    case UPLOAD_AVATAR_REQUEST:
    case REMOVE_AVATAR_REQUEST:
    case UPDATE_PROFILE_REQUEST:
    case RESET_PASSWORD_REQUEST:
    case CANCEL_SUBSCRIPTION_REQUEST:
    case ADD_CREDIT_REQUEST:
    case FETCH_USER_CARDS_REQUEST:
      return {
        ...state,
        isFetching: true,
        wasFetched: false,
      };
    case LOGIN_SUCCESS:
    case FETCH_USER_SUCCESS:
    case SOCIAL_SUCCESS:
      return {
        ...successCaseFabric('login', state),
        userData: action.payload,
      };
    case SIGNUP_SUCCESS:
      return {
        ...successCaseFabric('signup', state),
        userData: action.payload,
      };
    case LOGOUT_SUCCESS:
      return {
        ...successCaseFabric('logout', state),
        userData: null,
        cards: availablePaymentMethods,
      };
    case RETRIEVE_PASSWORD_SUCCESS: return successCaseFabric('forgot', state);
    case UPDATE_PASSWORD_SUCCESS: return successCaseFabric('updatePassword', state);
    case DEFINE_USER_COORDINATES_SUCCESS:
      return {
        ...state,
        location: {
          ...state.location,
          ...action.payload,
          wasFetched: true,
        }
      };
    case UPLOAD_AVATAR_SUCCESS:
      return {
        ...successCaseFabric('uploadAvatar', state),
        userData: {
          ...state.userData,
          avatar: action.payload,
        },
      };
    case REMOVE_AVATAR_SUCCESS:
      return {
        ...successCaseFabric('removeAvatar', state),
        userData: {
          ...state.userData,
          avatar: null,
        }
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...successCaseFabric('update', state),
        userData: action.payload,
      };
    case RESET_PASSWORD_SUCCESS: return successCaseFabric('reset', state);
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...successCaseFabric('cancelSubscription', state),
        userData: {
          ...state.userData,
          subscription: {...state.userData.subscription, ...action.payload},
        },
      };
    case ADD_CREDIT_SUCCESS:
      return {
        ...successCaseFabric('addCredit', state),
        newCredit: {
          ...action.payload,
        }
      }
    case FETCH_USER_CARDS_SUCCESS:
      return {
        ...successCaseFabric('cards', state),
        cards: [
          ...state.cards,
          action.payload
        ],
      };
    case LOGIN_FAILURE:
    case FETCH_USER_FAILURE:
    case SOCIAL_FAILURE: return failureCaseFabric('login', state, action.payload);
    case SIGNUP_FAILURE: return failureCaseFabric('signup', state, action.payload);
    case LOGOUT_FAILURE: return failureCaseFabric('logout', state, action.payload);
    case RETRIEVE_PASSWORD_FAILURE: return failureCaseFabric('forgot', state, action.payload);
    case RETRIEVE_PASSWORD_RESET:
      return {
        ...state,
        errors: { ...state.errors, forgot: null },
        success: { ...state.success, forgot: false },
      };
    case UPDATE_PASSWORD_FAILURE: return failureCaseFabric('updatePassword', state, action.payload);
    case DEFINE_USER_COORDINATES_FAILURE:
      return {
        ...state,
        location: {
          ...state.location,
          wasFetched: true,
        }
      };
    case UPLOAD_AVATAR_FAILURE: return failureCaseFabric('uploadAvatar', state, action.payload);
    case REMOVE_AVATAR_FAILURE: return failureCaseFabric('removeAvatar', state, action.payload);
    case UPDATE_PROFILE_FAILURE: return failureCaseFabric('update', state, action.payload);
    case RESET_PASSWORD_FAILURE: return failureCaseFabric('reset', state, action.payload);
    case CANCEL_SUBSCRIPTION_FAILURE: return failureCaseFabric('cancelSubscription', state, action.payload);
    case ADD_CREDIT_FAILURE: return failureCaseFabric('addCredit', state, action.payload);
    case FETCH_USER_CARDS_FAILURE: return failureCaseFabric('cards', state, action.payload);

    default:
      return state;
  }
}
